import { Pipe, PipeTransform } from '@angular/core';
import { DateProvider } from '@app/providers';

@Pipe({
    standalone: false,
    name: 'unixDurationToHuman',
})
export class UnixDurationToHumanFilter implements PipeTransform {
    constructor(private dateProvider: DateProvider) {}
    transform(data: any): string {
        return this.dateProvider.unixDurationToHuman(data);
    }
}

@Pipe({
    standalone: false,
    name: 'formatDateByPeriodType',
    pure: false, // ← re-évalue à chaque change detection
})
export class FormatDateByPeriodType implements PipeTransform {
    constructor(private dateProvider: DateProvider) {}
    transform(data: any, type: any): string {
        return this.dateProvider.selectedDateToActionBar(data, type);
    }
}
